// extracted by mini-css-extract-plugin
export default {"container":"cart-list_container__E5KRM","list":"cart-list_list__brJ2d","title":"cart-list_title__c5VAA","button":"cart-list_button__mWS+l","total":"cart-list_total__2KPw7"};